import HeroImageBackgroundContainer from 'components/HeroImageBackgroundContainer';
import { useState } from 'react';
import css from 'styled-jsx/css';
import {
  fetchUtmParamsJoinedWithFbDataFromLocalStorage,
  identifyUser,
  trackMailingListSignup,
} from 'utils/analytics/analytics';
import { authApiClient } from 'utils/apiClient';
import HttpStatusCode from 'utils/HttpStatusCode';
import RoundedButton from '../RoundedButton';

const StayInTheLoopSection = () => {
  const [email, setEmail] = useState('');
  const [successful, setSuccessful] = useState(false);

  return (
    <HeroImageBackgroundContainer style={{ color: 'white' }}>
      <div className="paddedMaxWidthContainer" style={{ paddingTop: '2em' }}>
        <h2 style={{ color: '#59FFDE', textShadow: `0px 0px 10px blue` }}>
          STAY IN THE <span className="outlineText">LOOP</span>
        </h2>

        <div
          style={{
            width: '280px',
            height: '2px',
            backgroundColor: '#59FFDE',
            boxShadow: `0px 0px 10px blue`,
            marginTop: '10px',
            marginBottom: '10px',
          }}
        />

        <input
          placeholder="Email Address"
          type="email"
          autoComplete="email"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />

        <p style={{ margin: '2em 1em', maxWidth: '300px', fontWeight: 600 }}>
          By clicking Submit, you agree to receive exclusive news and offers -
          NO spam (we promise).
        </p>

        {!successful ? (
          <RoundedButton
            style={{ minWidth: '180px', marginBottom: '2em' }}
            onClick={async () => {
              const utmParams =
                fetchUtmParamsJoinedWithFbDataFromLocalStorage();
              // expects Record<string, string> or null
              const formattedUtmParams = utmParams
                ? Object.fromEntries(
                    Object.entries(utmParams).map(([key, value]) => [
                      key,
                      typeof value === 'string' ? value : JSON.stringify(value),
                    ])
                  )
                : null;
              const res =
                await authApiClient.public.signUpForNewsletterWithDiscount({
                  body: {
                    emailAddress: email,
                    source: 'FOOTER',
                    utmParams: formattedUtmParams,
                  },
                });
              if (res.status === HttpStatusCode.OK) {
                setSuccessful(true);
                identifyUser({ emailAddress: email });
                trackMailingListSignup(email);
              }
            }}
          >
            SUBMIT
          </RoundedButton>
        ) : (
          <p
            style={{
              margin: '2em 1em',
              maxWidth: '300px',
              fontWeight: 'bold',
              fontSize: '1.3em',
            }}
          >
            Great, you're signed up!
          </p>
        )}
      </div>

      <style jsx>{styles}</style>
    </HeroImageBackgroundContainer>
  );
};

const styles = css`
  :global(.footer) {
    margin-top: 0 !important;
  }

  .outlineText {
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke-width: 1.5px;
    -webkit-text-stroke-color: #59ffde;
    text-shadow: 0 0 5px #00a1ff;
  }

  input {
    margin-top: 20px;
    background-color: rgba(0, 0, 0, 0.35);
    color: white;
    font-size: 17px;
    font-weight: 600;
    padding: 0.5em 1em;
    min-width: 250px;
    border-radius: 3px;
    border: 2px solid #50e3c2;
    box-shadow: 0px 0px 40px rgba(20, 20, 255, 0.5);
  }
`;

export default StayInTheLoopSection;
